import { isAndroid, isIOS, isNotNil, isWeb } from 'shared/src/utils';
import { useGoodsBasic } from './useGoodsBasic';
import { useEffect, useRef } from 'react';
import { useInstanceId, useOpenDeeplink } from 'shared/src/hooks';
import { useRootStackNavigation } from 'shared/src/hooks/useRootNavigation';
import { useGoodsSno } from '../hooks/useGoodsSno';

export const useCheckGoodsRedirectDeeplink = () => {
  const { data: goodsBasic, isSuccess } = useGoodsBasic();
  const { openDeeplink } = useOpenDeeplink();
  const instanceId = useInstanceId();
  const navigation = useRootStackNavigation();
  const redirect = useRef(false);
  const goodsSno = useGoodsSno();

  useEffect(() => {
    if (redirect.current) return;
    if ((isIOS || isAndroid) && isSuccess && isNotNil(goodsBasic)) {
      if (isNotNil(goodsBasic.redirect_deeplink)) {
        const state = navigation.getState();
        redirect.current = true;

        navigation.reset({
          ...state,
          routes: state.routes.map(route => {
            if (
              route.name === 'GoodsDetail' &&
              route.params.goodsId === goodsSno
            ) {
              return {
                ...route,
                name: 'WebViewScreen',
                params: {
                  url: goodsBasic.redirect_deeplink?.replace(
                    'ably://webview?url=',
                    '',
                  ),
                },
              };
            }
            return route;
          }),
        });

        return;
      }
    }

    if (isWeb && isNotNil(goodsBasic)) {
      if (isNotNil(goodsBasic.redirect_weblink)) {
        location.href = goodsBasic.redirect_weblink;
      }
    }
  }, [goodsBasic, goodsSno, instanceId, isSuccess, navigation, openDeeplink]);
};
